import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from "docz";
import NumericInput from "../src/NumericInput.tsx";
import "./styles.css";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "numericinput"
    }}>{`NumericInput`}</h1>
    <Props of={NumericInput} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <Playground __position={1} __code={'<NumericInput />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "defining-decimal-precision"
    }}>{`Defining decimal precision`}</h2>
    <Playground __position={2} __code={'<NumericInput decimalPrecision={2} value={50} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput decimalPrecision={2} value={50} mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "decimal-precision-and-maxlength"
    }}>{`Decimal precision and maxLength`}</h2>
    <Playground __position={3} __code={'<NumericInput decimalPrecision={2} maxLength={4} value={99999999} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput decimalPrecision={2} maxLength={4} value={99999999} mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "formatting-input-as-money"
    }}>{`Formatting input as money`}</h2>
    <Playground __position={4} __code={'<NumericInput decimalPrecision={2} maxLength={4} value={9} money />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput decimalPrecision={2} maxLength={4} value={9} money mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "formatting-input-as-percent"
    }}>{`Formatting input as percent`}</h2>
    <Playground __position={5} __code={'<NumericInput decimalPrecision={2} value={90} percent />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput decimalPrecision={2} value={90} percent mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "formatting-input-as-percent-with-large-decimal-precision"
    }}>{`Formatting input as percent with large decimal precision`}</h2>
    <Playground __position={6} __code={'<NumericInput decimalPrecision={4} value={90} percent />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput decimalPrecision={4} value={90} percent mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "calling-functions-on-events-onblur-onchange"
    }}>{`Calling functions on events (onBlur, onChange)`}</h2>
    <Playground __position={7} __code={'<NumericInput\n  decimalPrecision={2}\n  id=\"tot_debit\"\n  name=\"tot_debit\"\n  maxLength={20}\n  value={503.2}\n  onChange={e => console.log(e.target.name, e.target.value)}\n  onBlur={(e, val) => {\n    console.log(e.target.name, e.target.value)\n  }}\n  percent\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput decimalPrecision={2} id="tot_debit" name="tot_debit" maxLength={20} value={503.2} onChange={e => console.log(e.target.name, e.target.value)} onBlur={(e, val) => {
        console.log(e.target.name, e.target.value);
      }} percent mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "decimal-precision-and-maxlength-using-value-onblur"
    }}>{`Decimal precision and maxLength using value onBlur`}</h2>
    <Playground __position={8} __code={'<NumericInput\n  decimalPrecision={2}\n  maxLength={4}\n  value={99999999}\n  onChange={e => console.log(\'change\', e.target.value)}\n  onBlur={(e, val) => console.log(\'blur\', e.target.name, val)}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput decimalPrecision={2} maxLength={4} value={99999999} onChange={e => console.log("change", e.target.value)} onBlur={(e, val) => console.log("blur", e.target.name, val)} mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "thousand-separator-as-dot-"
    }}>{`Thousand separator as dot (.)`}</h2>
    <Playground __position={9} __code={'<NumericInput\n  decimalPrecision={2}\n  value={99999999}\n  thousandSeparator=\".\"\n  decimalSeparator=\",\"\n  onChange={e => console.log(\'change\', e.target.value)}\n  onBlur={(e, val) => console.log(\'blur\', e.target.name, val)}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput decimalPrecision={2} value={99999999} thousandSeparator="." decimalSeparator="," onChange={e => console.log("change", e.target.value)} onBlur={(e, val) => console.log("blur", e.target.name, val)} mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "thousand-separator-as-comma-"
    }}>{`Thousand separator as comma (,)`}</h2>
    <Playground __position={10} __code={'<NumericInput\n  decimalPrecision={2}\n  value={99999999}\n  thousandSeparator=\",\"\n  onChange={e => console.log(\'change\', e.target.value)}\n  onBlur={(e, val) => console.log(\'blur\', e.target.name, val)}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput decimalPrecision={2} value={99999999} thousandSeparator="," onChange={e => console.log("change", e.target.value)} onBlur={(e, val) => console.log("blur", e.target.name, val)} mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "test-with-thousand-separator-and-maxlength"
    }}>{`Test with thousand separator and maxLength`}</h2>
    <Playground __position={11} __code={'<NumericInput value={99999} maxLength={8} thousandSeparator=\",\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput value={99999} maxLength={8} thousandSeparator="," mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "working-with-large-numbers"
    }}>{`Working with large numbers`}</h2>
    <Playground __position={12} __code={'<NumericInput value={99999} maxLength={30} thousandSeparator=\",\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput value={99999} maxLength={30} thousandSeparator="," mdxType="NumericInput" />
    </Playground>
    <h2 {...{
      "id": "working-with-large-numbers-with-decimals"
    }}>{`Working with large numbers with decimals`}</h2>
    <Playground __position={13} __code={'<NumericInput\n  value={99999.9901}\n  maxLength={25}\n  thousandSeparator=\",\"\n  decimalPrecision={5}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      NumericInput,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <NumericInput value={99999.9901} maxLength={25} thousandSeparator="," decimalPrecision={5} mdxType="NumericInput" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      